module.exports = __webpack_public_path__ + "static/img/weChatPublic.16184c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/components/foot/components/weChatPublic.png
// module id = O496
// module chunks = 0